'use client';

import { Children, cloneElement } from 'react';

import { useMenuContext } from './MenuProvider';

import type { FC, ReactElement } from 'react';

/**
 * Alias for AnchorElement
 * used to delegate the anchor element handler
 *
 * @example
 * ```jsx
 *   <MenuController>
 *     <PopperToggle>
 *       <Button>Dashboard</Button>
 *     </PopperToggle>
 *     <PopoverDisplay>
 *       <MenuItem>
 *         <MenuItem>Profile</MenuItem>
 *       </MenuItem>
 *       <MenuItem>
 *         <MenuItem>My account</MenuItem>
 *       </MenuItem>
 *     </PopoverDisplay>
 *   </MenuController>
 * ```
 */

export interface MenuItemProps {
  children: ReactElement;
}

export const MenuItem: FC<MenuItemProps> = ({ children }) => {
  const { onClose } = useMenuContext();

  return (
    <>
      {Children.map( children, (child) => cloneElement( child, { onClick: onClose } ) )}
    </>
  );
};
